import { parseISO, addMinutes, subMinutes } from 'date-fns';

/**
 * Convert given date to UTC
 * @link https://github.com/date-fns/date-fns/issues/556#issuecomment-391048347
 * @param date | plain JS date object
 * @return {Date | *}
 */
export function toUTC(date) {
	const offset = date.getTimezoneOffset();

	return Math.sign(offset) !== -1 ? addMinutes(date, offset) : subMinutes(date, Math.abs(offset));
}

/**
 * Get now in UTC time.
 * @return {Date}
 */
export function utcnow() {
	const now = new Date();

	return toUTC(now);
}

/**
 * Converts a string representation of a Date to its Date object in UTC
 * @param str | string. Usually output from an <input type="date" />
 * @returns {Date}
 */
export function parseUTC(str) {
	const check = parseISO(str);
	const valid = check.toString() !== "Invalid Date";
	const date = valid ? check : new Date(str);
	return toUTC(date);
}

export function getFullFormat(date) {
	if (!date) return;

	const months = [
		"January", "February", "March",
		"April", "May", "June", "July",
		"August", "September", "October",
		"November", "December"
	];

	const day = date.getDate();
	const monthIx = date.getMonth();
	const year = date.getFullYear();

	return `${months[monthIx]} ${day}, ${year}`;
}
